import { useSettings } from './useSettings/useSettings';

/**
 * @deprecated Use `useisPolicyStreamOrganization` instead
 */
export const useOnLifeOrganization = () => {
  const {
    settings: { types: insuranceTypes },
  } = useSettings();
  return insuranceTypes.includes('LIFE');
};
